export default {
  setCourses(state, courses) {
    state.courses = courses;
  }
};
